/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { safeAreaInset } from "./config";
import { UAParser } from "utils/index";
import bbtNative from "@bbtfe/native";
import bbtVersion from '@bbtfe/version';

const SafeArea = (props) => {
  const {
    userAgent = {},
    router = {},
    position = "top",
    className = "",
    statusBarStyle = {},
    test = '',
    androidOriginBarHeight = undefined,
    resetBarHeight,
    nativeStatusBar
  } = props;
  const { location = {} } = router;
  const { navigation_bar_hidden } = location.query || {};
  const { iPhoneX, iPhone, pregnancy } = userAgent;
  const [barHeight, setBarHeight] = useState((window.androidStatusBarHeight || androidOriginBarHeight) ?? 32);

  if (bbtVersion.less('9.15.0')) {
    if (!iPhone) return null;
  }
  const isAndroid =
    navigator.userAgent.indexOf('Android') > -1 ||
    navigator.userAgent.indexOf('Adr') > -1;

  useEffect(() => {
    const cb = (height) => {
      if (height !== barHeight) {
        window.androidStatusBarHeight = height;
        setBarHeight(height);
      }
    };
    window.appendCbs ? window.appendCbs.push(cb) : (window.appendCbs = [cb]);
    //安卓手机返回状态栏的高度
    window.nativeStatusBarHeightCallBack = (height) => {
      if (height) {
        window.appendCbs.pop()(height);
      }
    };

    if (isAndroid) {
      //如果是安卓，隐藏状态栏  需要显示判断安卓机型，否则bbtNative.nativeStatusBarAction(1)会影响一部分ios机型
      bbtNative.nativeStatusBarAction(1);
    } else {
      if (position === 'top') {
        // 指定ios状态栏颜色 0 为黑，1 为白 ,入参字符串或数字均可，在lib端会统一转成string
        if (['0', '1'].includes(String(nativeStatusBar))) {
          bbtNative.nativeStatusBarAction(nativeStatusBar)
        }
      }
    }
  }, [nativeStatusBar]);
  useEffect(() => {
    resetBarHeight && resetBarHeight(barHeight);
  }, [barHeight])

  if (position === "top") {
    if (navigation_bar_hidden && pregnancy) {
      let style = safeAreaInset(
        position,
        iPhone ? (iPhoneX ? "IPhoneX" : "IPhone") : "Default"
      );
      if (bbtVersion.less('9.15.0')) {
        if (!style) return null;
      }
      if (!style && barHeight) {
        // 安卓
        style = {
          height: +barHeight,
          ...statusBarStyle,
        };
        return (
          <div
            className={`component-safearea ${className}`}
            style={style}
          ></div>
          // <div className={`component-safearea ${className}`} style={style} />
        );
      }
      return (
        <div className={`component-safearea ${className}`} style={style} />
      );
    }
    return null;
  } else {
    let style = safeAreaInset(
      position,
      iPhone ? (iPhoneX ? "IPhoneX" : "IPhone") : "Default"
    );
    if (!style && barHeight) {
      style = {
        bottom: +barHeight
      }
    }
    return <div className={`component-safearea ${className}`} style={style} />;
  }
};

const mapStateToProps = ({ meta, router }) => ({
  userAgent: meta.userAgent,
  router: router,
});

export default connect(mapStateToProps)(SafeArea);

export const getSafeStyle = function (position) {
  const userAgent = UAParser();
  const { iPhoneX, iPhone } = userAgent;
  const style = safeAreaInset(
    position,
    iPhone ? (iPhoneX ? "IPhoneX" : "IPhone") : "Default"
  );
  return style;
};
